module.exports = __webpack_public_path__ + "img/tapper.fc93e83.svg";